import {useState} from "react";
import {signInErrorText, signInWithGoogle} from "../firebase";

export function SignIn() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const go = async () => {
    setBusy(true);
    setError(null);
    try {
      await signInWithGoogle();
    } catch (e) {
      setError(signInErrorText(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="card-page">
      <section className="card">
        <h1>Nefes — Gün</h1>
        <p>Günün programı, danışman danışman. Nefes hesabınızla girin.</p>
        <button className="primary" onClick={go} disabled={busy}>
          {busy ? "Giriş penceresi açık…" : "Google ile giriş"}
        </button>
        {error && <p className="error" role="alert">{error}</p>}
      </section>
    </main>
  );
}
